import IMG from "../../constants/image";
import Input from "../Common/Input";
import Button from "../Common/Button";
import React, {useState} from "react";
import {LOCAL_STORAGE_KEY, VARIANT} from "../../constants";
import './style.css';
import {merchantForgotPassword, merchantLogin} from "../../network/api";
import authStore from "../../store/authStore";
import {useLocation, useNavigate} from "react-router-dom";
import {handleNavigation} from "../../services/services";
import merchantStore from "../../store/merchantStore";
import {ERROR_CODE} from "../../constants/error";


const StepLoginPassword = ({setStep, setForgot}) => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const {phoneNumber, setConfirmId} = authStore() || {};
    const {getMerchantProfile} = merchantStore() || {};
    const location = useLocation();
    const {pathname} = location || {};
    const [error, setError] = useState('');

    const handleForgotPassword = async () => {
        const res = await merchantForgotPassword({phoneNumber})
        if (res?.success) {
            setConfirmId(res?.data?.data?.confirmId || '')
            setForgot(true)
            setStep(1)
        }
    }

    const handleLogin = async () => {
        const res = await merchantLogin({phoneNumber, password})
        if (res?.success && res?.data?.data?.accessToken) {
            window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, res?.data?.data?.accessToken || '')
            window.localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, res?.data?.data?.refreshToken || '')
            const profile = await getMerchantProfile(res?.data?.data?.accessToken)
            handleNavigation({navigate, merchantProfile: profile, pathname})
        } else if (res?.data?.code === ERROR_CODE['AUTH-002']) {
            setError('Mật khẩu hiện tại không đúng')
        }
    }

    return (
        <div
            className='w-[320px] md:w-[400px] py-[15px] px-[20px] md:px-[50px] md:py-[15px] text-xs bg-white rounded-2xl z-[1]'>
            <form className='flex flex-col justify-center items-center text-center gap-5' action="" autoComplete='off'
                  onSubmit={handleLogin}>
                <h2 className='text-sm font-bold'>Nhập mật khẩu</h2>
                <p
                    className='text-xs text-[#9E9E9E]'>{`Xin chào ${phoneNumber} nhập mật khẩu để đăng nhập vào tài khoản của bạn`}</p>
                <Input
                    type='password'
                    autoComplete="new-password"
                    className='w-full h-[44px]'
                    icon={IMG.icon.phoneIpBlack}
                    iconR={IMG.icon.eyeBlack}
                    placeholder='Nhập mật khẩu'
                    error={error}
                    setError={setError}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Button type='submit' variant={VARIANT.PRIMARY} className='w-full h-[44px]' onClick={handleLogin}>Tiếp
                    tục</Button>

                <Button className='text-[#197D55]' onClick={handleForgotPassword}>Quên mật khẩu?</Button>

            </form>
        </div>
    );
}

export default StepLoginPassword;
